export const ENDPOINTS = {
    GET_SPECIALTIES : 'getSpecialties',
    GET_CATEGORIES  : 'getCategories',
    GET_ORGANIZATIONS : 'getOrganizations',
    GET_PROFESSIONS   : 'getProfessions',
    GET_SUMMARIES_FOR_CATEGORY  : 'getSummariesForCategory',
    GET_SUMMARIES_FOR_SPECIALTY : 'getSummariesForSpecialty',
    GET_SUMMARIES_FOR_ORGANIZATION : 'getSummariesForOrganization',
    GET_SUMMARIES_FOR_PROFESSION   : 'getSummariesForProfession',
    GET_SUMMARY_BY_ID : 'getSummary',
    SEARCH_SUMMARIES : 'searchSummaries'
};